import { ApiPackage } from '@bhtp-client-api/base';
import { PackageAgreement } from '@bhtp-client-api/purchase';

export class NavigationConfig {
    public hasTravelerStep: boolean;
    public hasCoveragesStep: boolean;
    public hasFlightStep: boolean;
    public hasTripStep: boolean;

    public sessionId: number;
    public customerId: string;
    public initialStep: string;
    public ratingId: string;
    public package: ApiPackage;
    public agreementsForAgent: PackageAgreement;
    public loadedQuote: boolean = false;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/navigation-config.model.ts